'use strict';

angular.module('programme')

.component('programmeCarousel', {
    controller: 'ProgrammeCarouselCtrl',
    templateUrl: 'modules/programme/components/carousel.html',
    bindings: {
        items: '<'
    }
})

.controller('ProgrammeCarouselCtrl', function ()
{
});
